export default function WhyParticipate() {
  const benefits = [
    {
      icon: 'ri-user-search-line',
      title: 'Avaliação Profissional',
      desc: 'Feedback de especialistas sobre seu potencial real no mercado da moda e entretenimento.'
    },
    {
      icon: 'ri-star-line',
      title: 'Oportunidade Real',
      desc: 'Acesso direto a trabalhos em moda, publicidade e entretenimento nacional e internacional.'
    },
    {
      icon: 'ri-building-line',
      title: 'Ambiente Profissional',
      desc: 'Seletiva real com estrutura completa, equipe qualificada e metodologia comprovada.'
    },
    {
      icon: 'ri-rocket-line',
      title: 'Desenvolvimento Artístico',
      desc: 'Orientação profissional, networking e conexão com o mercado para impulsionar sua carreira.'
    }
  ];

  return (
    <section className="py-14 sm:py-20 lg:py-28 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
        <div className="text-center mb-10 sm:mb-14 lg:mb-16">
          <p className="text-xs font-bold text-yellow-600 tracking-widest uppercase mb-3">
            Sua oportunidade real
          </p>
          <h4 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-white mb-3">
            <a href="#beneficios">
              Por Que <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-500 to-yellow-600">Participar</span>
            </a>
          </h4>
          <p className="text-sm sm:text-base lg:text-lg text-gray-400 max-w-xl mx-auto">
            Mais do que uma seletiva. Uma porta para o mercado.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 lg:gap-6">
          {benefits.map((benefit, idx) => (
            <div key={idx} className="bg-gradient-to-br from-gray-900 to-black rounded-2xl p-5 sm:p-8 lg:p-8 border border-yellow-500/20 hover:border-yellow-500 transition-all duration-300 group cursor-pointer flex flex-col">
              <div className="w-11 h-11 sm:w-12 sm:h-12 lg:w-14 lg:h-14 bg-gradient-to-br from-yellow-500 to-yellow-600 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300 mb-4 lg:mb-5">
                <i className={`${benefit.icon} text-xl lg:text-2xl text-black`}></i>
              </div>
              <h3 className="text-base sm:text-xl lg:text-xl font-bold text-white mb-2">{benefit.title}</h3>
              <p className="text-gray-400 text-sm leading-relaxed">{benefit.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}